export default function (context) {
    if (context.$auth.$state.user?.Role) {
        if (!context.$auth.$state.user.Role.includes('hcp_casip_view')) {
            context.redirect('/Dashboard')
        }
    }
}
